export type LcmsActivityDto = {
  id: string;
  title: string;
  description: string | undefined;
  type?: string;
};

export enum LcmsActivityType {
  Lesson = "Lesson",
  Assessment = "Assessment",
  LiveClassroom = "LiveClassroom",
  Resources = "Resources",
}

export enum LcmsAssessmentType {
  Quiz = "Quiz",
  Test = "Test",
  Project = "Project",
  Exam = "Exam",
  Participation = "Participation",
  External = "External",
  KnowledgeCheck = "KnowledgeCheck",
  Assignment = "Assignment",
}

export enum LcmsCourseType {
  Standard = "Standard",
  Advisory = "Advisory",
  Homeroom = "Homeroom",
  External = "External",
}

export type LcmsExtendedActivityDto = {
  id: string;
  type: LcmsActivityType;
  tenantId: string;
  title: string;
  description: string;
  standards: string[];
  tags: string[];
  sources: string[];
  isMandatory: boolean;
  settings: {
    hasArtifact: boolean;
    assessmentType: LcmsAssessmentType;
    startTime: string;
    endTime: string;
    hasTimeLimit: boolean;
    timeLimitInMinutes: number;
  };
  nestedStandards: Record<string, string[]>;
  courseType: LcmsCourseType;
  isDeleted: boolean;
  isPublished: boolean;
  isDisabled: boolean;
  createdBy: string;
  createdOn: string;
  updatedBy: string;
  updatedOn: string;
  correlationId: string;
  isDefault: boolean;
  originalId: string;
  variantName: string;
  pages: {
    id: string;
    title: string;
    simpleLayout: {
      assets: string[];
    };
  }[];
};

export enum LcmsAssetType {
  Attachments = "Attachments",
  Audio = "Audio",
  AudioAnswer = "AudioAnswer",
  BlockQuote = "BlockQuote",
  Category = "Category",
  CollapsibleBox = "CollapsibleBox",
  Confirmation = "Confirmation",
  ContentIntegration = "ContentIntegration",
  DiscussionAnswer = "DiscussionAnswer",
  Divider = "Divider",
  EPubEmbed = "EPubEmbed",
  FileUpload = "FileUpload",
  Gallery = "ImageGallery",
  Hotspot = "Hotspot",
  HotspotAnswer = "HotspotAnswer",
  HotspotLabel = "HotspotLabel",
  Image = "Image",
  Instruction = "Instruction",
  MatchingList = "MatchingList",
  Multistep = "Multistep",
  MultipleChoice = "MultipleChoice",
  PasteId = "PasteId",
  QuestionContainer = "QuestionContainer",
  SectionHeader = "SectionHeader",
  Sketchpad = "Sketchpad",
  SortableList = "SortableList",
  SupplementalContent = "SupplementalContent",
  Table = "Table",
  Text = "Text",
  TextAnswer = "TextAnswer",
  ThreeColumn = "ThreeColumn",
  Timeline = "Timeline",
  TwoColumn = "TwoColumn",
  Video = "Video",
  VideoAnswer = "VideoAnswer",
  YouPick = "YouPick",
}

export type LcmsAssetDto = {
  id: string;
  tenantId: string;
  title: string;
  type: LcmsAssetType;
  standards: string[];
  settings: object;
  externalId: string;
  isPublished: boolean;
  isDeleted: boolean;
  isPublic: boolean;
  createdOn: string;
};

export type ActivityContentRevisionDto = {
  id: string;
  templateEventId: string;
  activityId: string;
  contentVersion: number;
  contentHash: string;
  activity: LcmsExtendedActivityDto;
  assets: LcmsAssetDto[];
  createdOn: string;
};
